import { createFileRoute, Outlet } from '@tanstack/react-router'
import { setLocale, initLocale, locales } from '../i18n/translator'
import NotFound from './-not-found'

export const Route = createFileRoute('/$locale')({
  beforeLoad: ({ params }) => {
    const locale = params.locale as keyof typeof locales
    // Only valid, supported locale prefixes reach here (the root route
    // already redirects everything else). Set + initialize the bundle.
    if (locales[locale]) {
      setLocale(locale)
      initLocale(locale)
    }
  },
  notFoundComponent: NotFound,
  component: () => <Outlet />,
})
